
import { Component, Vue } from 'vue-property-decorator'
import { apiDownloadList } from '@/api/app'

import { RequestPaging } from '@/utils/util'
import LsPagination from '@/components/ls-pagination.vue'
@Component({
    components: {
        LsPagination
    }
})
export default class productLine extends Vue {
    $refs!: {
        form: any
    }

    pager = new RequestPaging()
    form: any = {
        status: '',
        name: ''
    }

    selectionList: any = []

    setStatusCh(status: any) {
        switch (status) {
            case 0:
                return '等待生成数据'
            case 1:
                return '已完成'
            case 2:
                return '等待下载'
            case 3:
                return '等待合成'
            case 4:
                return '错误'
        }
    }

    showRetry(item: any) {
        const currentTimestamp = new Date().getTime()
        const createTime = Date.parse(item.create_time)
        const timeDiff = currentTimestamp - createTime
        if (timeDiff > 10 * 60 * 1000 && item.finish_time === null) {
            return true
        } else {
            return false
        }
    }

    changeSelection(e: any) {
        this.selectionList = e.map((e: any) => e.id)
    }

    downLoadZip(url: string) {
        window.open(url)
    }

    timestampToYYMMDDHHMMSS(timestamp: number) {
        let date = new Date(timestamp * 1000) // 将时间戳转换为毫秒
        let year = date.getFullYear()
        let month = ('0' + (date.getMonth() + 1)).slice(-2)
        let day = ('0' + date.getDate()).slice(-2)
        let hours = ('0' + date.getHours()).slice(-2)
        let minutes = ('0' + date.getMinutes()).slice(-2)
        let seconds = ('0' + date.getSeconds()).slice(-2)

        let formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
        return formattedDate
    }

    econdsToMinutes(seconds: number) {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes} 分钟 ${remainingSeconds} 秒`
    }

    getProductLine(page?: number): void {
        page && (this.pager.page = page)
        this.pager.request({
            callback: apiDownloadList,
            params: this.form
        })
    }

    created() {
        this.getProductLine()
    }
}
